/*
  Filter bar and table-cell styles for the list screens.

  Bookings, payments, students, and feedback all share this shape, so the
  classes are written once and imported where needed rather than duplicated
  per screen with slight drift.
*/

.filters {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border);
}

.search {
  flex: 1;
  min-width: 200px;
  max-width: 320px;
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
}

.search:focus,
.select:focus {
  outline: none;
  border-color: var(--indigo);
  box-shadow: 0 0 0 3px rgb(79 63 240 / 15%);
}

.select {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  cursor: pointer;
  min-height: 34px;
}

.dateRange {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.dateSeparator {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.clear {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text-muted);
  background: transparent;
  border: none;
  border-radius: var(--radius);
  text-decoration: underline;
}

.clear:hover { color: var(--text); }

/* ----------------------------------------------------------- table cells */
.primary {
  font-weight: var(--weight-medium);
  color: var(--text);
}

.secondary {
  margin-top: 2px;
  font-size: var(--text-xs);
  color: var(--text-muted);
  line-height: var(--leading-normal);
}

.statusCell {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  align-items: flex-start;
}

.refund {
  margin-top: 2px;
  font-size: var(--text-xs);
  color: var(--warning);
}

.muted { color: var(--text-subtle); }

.mono {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* *** A SESSION THAT COULD NOT HAPPEN, AND WAS PAID FOR ***
   The only cancellation reason that asks the reader to act. Everything else in
   this column is grey secondary text, so this deliberately is not: an admin
   scanning a page of cancellations must see this one without looking for it.

   Amber rather than red — the session is already handled (returned on a plan,
   flagged on a per-session tenant), so this is "look at this", not "something
   is on fire". */
.failedSession {
  display: inline-block;
  margin-top: 3px;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  background: var(--warning-soft);
  color: var(--warning);
  border: 1px solid var(--warning);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-normal);
  cursor: help;
}
